import * as _ from 'lodash'
import React from 'react';
import componentServices from '../componentServices';
import * as actions from '../actions';
import valueFilters from '../valueFilters';
import util from '../util';
import enums from '../enum';
import globalRelay from '../globalRelay';
import * as jobActions from '../jobActions';import * as vendorActions from '../vendorActions';import jobFactory from '../models/jobModel';
import * as jobCostActions from '../jobCostActions';import jobCostFactory from '../models/jobCostModel';
import JobCostSummary from '../models/jobCostSummary';
import { Confirm, PercentInput, Spinner } from './sharedComponents';
import { getModel, ModelCollection } from 'Scripts/store';

const globalConfig = globalRelay.config!;

const InputRow = ({ children, isValid, label }) => {
	const className = !isValid ? 'required' : '';
	return (
		<tr className={ className }>
			<td />
			<td><strong>{ label }</strong></td>
			<td>{ children }</td>
			<td />
		</tr>
	);
};

export default class JobCostCreateModal extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps();

		this.cancel = this.cancel.bind(this);
		this.selectBaseTemplate = this.selectBaseTemplate.bind(this);
		this.save = this.save.bind(this);
		this.onCheckboxChange = this.onCheckboxChange.bind(this);
		this.onIsRenovationChange = this.onIsRenovationChange.bind(this);
		this.setVariant = this.setVariant.bind(this);

		this._ensureInstallationConfig();
	}

	getStateFromProps () {
		const currentEmployee = componentServices.securityContext.getCurrentEmployee();
		const currentModule = componentServices.routeParams.modulekey;
		const marginKey = currentModule && currentModule.split('-')[0];

		const state = _.assign({
			isRenovation: false,
			placeholderJobCost: jobCostFactory({ margin: globalConfig.jobCostSettings.defaultMargin && globalConfig.jobCostSettings.defaultMargin[marginKey] }),
			selectedTemplate: undefined,
			workAreaKeysToClone: [],
			selectedVariant: (currentEmployee && currentEmployee.getProfileValue('defaultCompanyVariant')) || globalConfig.variant
		}, this.state);

		this.setWorkAreasToClone(state);
		this.setContractorTemplates(state);

		return state;
	}

	updateState (updater) {
		this.setState(previousState => {
			const nextState = _.assign({}, previousState);
			updater(nextState);
			return nextState;
		});
	}

	_ensureInstallationConfig () {
		const configs:string[] = [];

		_.forEach(globalConfig.variants, v => {
			const installConfigName = actions.formatConfigName({ companyVariant: v.variant });

			if (configs.indexOf(installConfigName) === -1) {
				configs.push(installConfigName);
			}
		});

		_.forEach(configs, c => {
			const installationConfig = componentServices.store.getIn(['model', 'config', _.camelCase(c)]);
			if (installationConfig === undefined) {
				actions.fetchConfig({ name: c });
			}
		});
	}

	selectBaseTemplate (e) {
		const targetKey = e.target.value;

		this.updateState(nextState => {
			nextState.selectedTemplate = _.find(nextState.contractorTemplates, { key: targetKey });

			if (nextState.selectedTemplate) {
				nextState.placeholderJobCost.margin = nextState.selectedTemplate.margin;
			}

			this.setWorkAreasToClone(nextState);
		});
	}

	setWorkAreasToClone (state) {
		if (state.selectedTemplate) {
			state.workAreaKeysToClone = _.map(state.selectedTemplate.workAreas, workArea => workArea.key);
		}
		else {
			state.workAreaKeysToClone = [];
		}
	}

	setContractorTemplates (state) {
		const { contractorTemplates = []} = this.props;

		state.contractorTemplates = _.sortBy(_.filter(contractorTemplates, { companyVariant: state.selectedVariant }), ['name']);

		if (state.selectedTemplate && state.selectedTemplate.companyVariant !== state.selectedVariant) {
			state.selectedTemplate = undefined;
			this.setWorkAreasToClone(state);
		}
	}

	setVariant (e) {
		const variant = e.target.value;

		this.updateState(nextState => {
			nextState.selectedVariant = variant;
			this.setContractorTemplates(nextState);
		});
	}

	cancel () {
		this.props.close();
	}

	async _loadLineItemRelatedModelsForSave (lineItem) {
		if (lineItem.vendorKey) {
			const { store } = componentServices;
			const vendor = getModel({ store, collection: ModelCollection.vendors, key: lineItem.vendorKey });

			if (!vendor) {
				// fetch all the vendors on the first missing vendor to prevent multiple fetches
				await vendorActions.fetchVendors({ type: enums.vendorTypes.Outside_Supplier | enums.vendorTypes.Internal_Warehouse | enums.vendorTypes.Cabinet_Supplier });
			}
		}
	}

	async _saveJobCost () {
		const { placeholderJobCost, selectedTemplate, selectedVariant, workAreaKeysToClone } = this.state;
		const { jobKey, contractorKey } = this.props;
		const newJobCost = selectedTemplate ? selectedTemplate.clone(undefined, workAreaKeysToClone) : placeholderJobCost;

		newJobCost.name = placeholderJobCost.name;
		newJobCost.margin = placeholderJobCost.margin;
		newJobCost.contractorKey = contractorKey;
		newJobCost.jobKey = jobKey;
		newJobCost.type = contractorKey ? 'template' : 'quote';
		newJobCost.companyVariant = selectedVariant;
		newJobCost.requiresDelivery = true;
		newJobCost.requiresInstall = true;

		const summary = new JobCostSummary(newJobCost, 0);

		summary.buildItems();

		// if all template work areas are not included or if the jobCost adjustedSellPrice equals the summary calculated price, wipe out the adjusted sell price
		if (selectedTemplate && (selectedTemplate.workAreas.length() > workAreaKeysToClone.length || summary.orderCaculatedSellPrice === newJobCost.adjustedSellPrice)) {
			newJobCost.adjustedSellPrice = null;
		}

		globalRelay.triggerJobCostCreate(newJobCost);
		// ensure that the margin values are properly set on line items
		globalRelay.triggerJobCostUpdate(newJobCost, summary, 'margin');

		// Trigger updates that could impact cost/pricing based on values external to the job cost
		// Order matters here
		for (const lineItem of newJobCost.lineItems.toArray()) {
			await this._loadLineItemRelatedModelsForSave(lineItem);
			globalRelay.triggerJobCostLineUpdate(lineItem, 'productName', newJobCost);
			globalRelay.triggerJobCostLineUpdate(lineItem, 'glassTypeKey', newJobCost);
			globalRelay.triggerJobCostLineUpdate(lineItem, 'doorSizeKey', newJobCost);
			globalRelay.triggerJobCostLineUpdate(lineItem, 'listPrice', newJobCost);
		}

		// trigger this a second time to be sure that any line updates are accounted for
		globalRelay.triggerJobCostUpdate(newJobCost, summary, 'margin');

		await jobCostActions.saveJobCost({ jobCost: newJobCost.toDocument() });

		return newJobCost.key;
	}

	_save () {
		const { store } = componentServices;
		const { isRenovation } = this.state;
		const { jobKey, contractorKey, close } = this.props;
		const job = jobKey && getModel({ store, collection: ModelCollection.jobs, key: jobKey });
		const saveModalKey = 'create-jobcost-modal-spinner';

		let jobSavePromise = Promise.resolve();
		if (job && job.requiresInitialization) {
			const saveJob = jobFactory(job.toDocument());

			saveJob.requiresInitialization = false;
			saveJob.isRenovation = (isRenovation === '1');

			const patch = saveJob.getPatch(job);

			jobSavePromise = jobActions.saveJob({ job: saveJob.toDocument(), patch });
		}

		actions.pushModal({ key: saveModalKey, component: (<Spinner />) });

		jobSavePromise.then(() => {
			this._saveJobCost()
				.then(newJobCostKey => {
					componentServices.router.pushHistory(componentServices.router.pushPathSegments(newJobCostKey, 'setup'));
				})
				.catch(err => {
					actions.pushAlert({ type: 'error', message: contractorKey ? 'Template creation failed.' : 'Estimate creation failed', isCloseable: true, orgininalError: err });
				})
				.finally(() => {
					actions.deleteModal({ key: saveModalKey });
					close();
				});
		});
	}

	save () {
		const { placeholderJobCost, selectedTemplate, workAreaKeysToClone } = this.state;

		if (!this.canAttemptSave()) {
			return;
		}

		if (!placeholderJobCost.isValid()) {
			this.updateState(nextState => {
				nextState.saveAttempted = true;
			});
			return;
		}

		if (selectedTemplate && selectedTemplate.workAreas.length() > workAreaKeysToClone.length) {
			const confirmHandler = () => {
				actions.popModal();

				this._save();
			};

			actions.pushModal({
				component: <Confirm title="Warning" message="Removing a work area will prevent the model base price from pulling into the new estimate. Are you sure you want to proceed?" confirmLabel="Yes" cancelLabel="No" cancelHandler={ actions.popModal } confirmHandler={ confirmHandler } />
			});
		}
		else {
			this._save();
		}
	}

	onInputChange (path, e) {
		const newVal = e.type === 'blur' ? valueFilters.clean(e.target.value) : e.target.value;

		this.updateState(nextState => {
			nextState.placeholderJobCost.setAt(path, newVal);
		});
	}

	onCheckboxChange (e) {
		const isChecked = e.target.checked;
		const key = e.target.value;

		this.updateState(nextState => {
			const existingIndex = nextState.workAreaKeysToClone.indexOf(key);

			if (!isChecked) {
				if(existingIndex !== -1) {
					nextState.workAreaKeysToClone.splice(nextState.workAreaKeysToClone.indexOf(key), 1);
				}
			}
			else if(existingIndex === -1) {
				nextState.workAreaKeysToClone.push(key);
			}
		});
	}

	onIsRenovationChange (e) {
		const newVal = e.target.value;

		this.updateState(nextState => {
			nextState.isRenovation = newVal;
		});
	}

	canAttemptSave () {
		const { placeholderJobCost, selectedTemplate, workAreaKeysToClone } = this.state;

		// TODO: finish this
		return !!placeholderJobCost.name && !!placeholderJobCost.margin && (!selectedTemplate || !!workAreaKeysToClone.length);
	}

	getBuilderRows () {
		const { contractorTemplates, selectedTemplate, workAreaKeysToClone } = this.state;
		const rows:JSX.Element[] = [];

		if (contractorTemplates.length) {
			const templateOptions = contractorTemplates.map(jobCost => (<option key={jobCost.key} value={jobCost.key}>{jobCost.name}</option>));
			const workAreas:JSX.Element[] = [];

			templateOptions.unshift(<option key="empty" value="">Select a Template</option>);
			if (selectedTemplate) {
				_.forEach(selectedTemplate.workAreas, workarea =>{
					workAreas.push(<label key={workarea.key}><input type="checkbox" checked={(workAreaKeysToClone.indexOf(workarea.key) !== -1)} value={workarea.key} onChange={this.onCheckboxChange}/>{ workarea.name }</label>);
				});
			}

			rows.push(<tr key="template">
				<td />
				<td><strong>Start with a Builder Model?</strong></td>
				<td>
					<select onChange={ this.selectBaseTemplate }>
						{templateOptions}
					</select>
				</td>
				<td />
			</tr>);
			rows.push(<tr key="workAreas">
				<td />
				<td className={ workAreas.length === 0 ? 'disabled' : ''}><strong>Included Model Work Areas</strong></td>
				<td className={ workAreas.length === 0 ? 'disabled' : ''}>
					{ workAreas.length ? workAreas : <label>No Work Areas Available</label> }
				</td>
				<td />
			</tr>);
		}

		return rows;
	}

	getVariantRow () {
		const { selectedVariant } = this.state;
		const variants = globalConfig.variants;

		if (variants.length > 1) {
			const variantInputs = _.map(variants, v => <label key={ v.variant }><input type="radio" name="variant" value={ v.variant } checked={ v.variant === selectedVariant } onChange={ this.setVariant } /><span className="badge" style={{ backgroundColor: v.badge.color }}><span>{ v.shortCompanyName.toUpperCase() }</span></span></label>);

			return (<tr>
				<td />
				<td><strong>Company Variant</strong></td>
				<td>
					{ variantInputs }
				</td>
				<td />
			</tr>);
		}
	}

	getInitializationRows () {
		const { store } = componentServices;
		const { isRenovation } = this.state;
		const { jobKey } = this.props;
		const job = jobKey && getModel({ store, collection: ModelCollection.jobs, key: jobKey });

		if (job && job.requiresInitialization) {
			return (<tr>
				<td />
				<td><strong>Job Type</strong></td>
				<td>
					<select value={ util.reactVal(isRenovation) } onChange={ this.onIsRenovationChange }><option value="">Select</option><option value="0">New Home</option><option value="1">Renovation</option></select>
				</td>
				<td />
			</tr>);
		}
	}

	render () {
		const { placeholderJobCost, selectedTemplate, saveAttempted } = this.state;

		return (
			<div className="window">
				<header>
					<button className="cancel" onClick={this.cancel} ><span>Cancel</span> </button>
					<span>New Estimate</span>
					<button className={ this.canAttemptSave() ? 'action save' : 'disabled action save'} onClick={this.save} ><span>SAVE</span></button>
				</header>
				<div className="views">
					<div className="content in scrollable">
						<section>
							<div className="inner">
								<table className="centered" cellPadding="0" cellSpacing="0">
									<tbody>
										{ this.getInitializationRows() }
										{ this.getVariantRow() }
										<InputRow key='name' isValid={!saveAttempted || placeholderJobCost.isValid('name')} label="Name"><input type="text" onChange={this.onInputChange.bind(this, 'name')} onBlur={this.onInputChange.bind(this, 'name')} placeholder="Enter a Name for this Estimate" autoCapitalize="" autoCorrect="off" value={placeholderJobCost.viewValue('name')} /></InputRow>
										<InputRow key='margin' isValid={!saveAttempted || placeholderJobCost.isValid('margin')} label="Default Margin"><PercentInput type="text" className={ selectedTemplate ? 'disabled' : '' } onChange={ selectedTemplate ? null : this.onInputChange.bind(this, 'margin')} onBlur={ selectedTemplate ? null : this.onInputChange.bind(this, 'margin')} placeholder="" value={placeholderJobCost.viewValue('margin')} /></InputRow>
										{ this.getBuilderRows() }
									</tbody>
								</table>
							</div>
						</section>
					</div>
				</div>
			</div>
		);
	}
}